import React, { memo } from "react"
import {
  ComposableMap,
  Geographies,
  Geography,
  ZoomableGroup,
  Marker,
} from "react-simple-maps"

import { markers, playlistMarkers } from "../country-playlist"

import katikaMarker from "../../assets/images/katikaMarker.svg"

import "./_simple-map-chart.scss"

const countries_url =
  "https://raw.githubusercontent.com/deldersveld/topojson/master/world-countries-sans-antarctica.json"

const rounded = num => {
  if (num > 1000000000) {
    return Math.round(num / 100000000) / 10 + "Bn"
  } else if (num > 1000000) {
    return Math.round(num / 100000) / 10 + "M"
  } else {
    return Math.round(num / 100) / 10 + "K"
  }
}

const SimpleMapChart = ({ setTooltipContent, setCountryCode }) => {
  const handleClick = geo => () => {
    setCountryCode(geo["Alpha-2"])
  }

  const handleMarkerClick = alpha2 => () => {
    setCountryCode(alpha2)
  }

  return (
    <div className="simple-map-chart">
      <div className="simple-map-chart__container">
        <ComposableMap
          data-tip=""
          projection="geoMercator"
          projectionConfig={{ scale: 110 }}
        >
          <ZoomableGroup>
            <Geographies geography={countries_url}>
              {({ geographies }) =>
                geographies.map(geo => (
                  <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    onClick={handleClick(geo.properties)}
                    onMouseEnter={() => {
                      const { name } = geo.properties
                      setTooltipContent(name)
                    }}
                    onMouseLeave={() => {
                      setTooltipContent("")
                    }}
                    style={{
                      default: {
                        fill: "#AE0D0D",
                        fillOpacity: 0.8,
                        outline: "none",
                        strokeWidth: 0.3,
                        stroke: "#17141d",
                      },
                      hover: {
                        fillOpacity: 1.0,
                        cursor: "pointer",
                        fill: "#ffffff",
                        outline: "none",
                      },
                      pressed: {
                        fill: "#AE0D0D",
                        outline: "none",
                        strokeWidth: 0.3,
                        stroke: "#17141d",
                      },
                    }}
                  />
                ))
              }
            </Geographies>
            {markers.map(({ lngLat, name, alpha2 }) => (
              <Marker
                key={name}
                coordinates={lngLat}
                onMouseEnter={() => {
                  setTooltipContent(name)
                }}
                onMouseLeave={() => {
                  setTooltipContent("")
                }}
                onClick={handleMarkerClick(alpha2)}
              >
                <circle r={1} fill="#F00" />
              </Marker>
            ))}
            {playlistMarkers.map(({ lngLat, name }) => (
              <Marker key={name} coordinates={lngLat}>
                <g
                  transform="translate(-22,-23) scale(0.02,-0.02)"
                  fill="#C7B349"
                  stroke="none"
                >
                  <path
                    d="M526 1219 c-58 -14 -146 -64 -196 -112 -129 -125 -172 -302 -114
                -475 46 -138 190 -367 304 -484 96 -99 136 -102 227 -15 31 29 96 113 145 187
                163 245 211 378 189 519 -28 181 -144 320 -312 372 -65 20 -175 24 -243 8z
                m209 -34 c127 -34 221 -112 278 -232 24 -53 32 -84 35 -148 5 -101 -12 -167
                -74 -285 -119 -224 -279 -420 -344 -420 -22 0 -114 97 -185 195 -181 249 -245
                416 -215 560 50 240 278 389 505 330z"
                  />
                  <path
                    d="M541 1124 c-30 -8 -70 -24 -89 -36 l-34 -21 4 -143 c2 -79 7 -147 11
                -151 12 -11 337 313 337 337 0 11 -90 30 -138 29 -20 0 -61 -7 -91 -15z"
                  />
                  <path
                    d="M730 983 c-98 -108 -109 -123 -91 -123 19 0 92 -73 133 -133 22 -33
                56 -94 76 -136 l35 -76 33 39 c126 146 94 402 -64 515 l-27 19 -95 -105z"
                  />
                  <path
                    d="M333 968 c-39 -65 -53 -116 -53 -189 0 -70 21 -142 60 -199 l30 -45
                0 243 c0 133 -1 242 -3 242 -1 0 -17 -24 -34 -52z"
                  />
                  <path
                    d="M492 757 l-65 -64 -5 -100 -5 -100 38 -22 c97 -57 229 -63 331 -17
                l54 25 -16 38 c-74 177 -178 303 -249 303 -10 0 -47 -29 -83 -63z"
                  />
                </g>
              </Marker>
            ))}
          </ZoomableGroup>
        </ComposableMap>
      </div>
    </div>
  )
}

export default SimpleMapChart
